module.exports = __webpack_public_path__ + "static/media/gain_gold.c01ce1a4.png";